import * as React from 'react';
import { rgba } from 'polished';
import styled from 'styled-components';

import { ArrowRightIcon } from '../../icons/Icons';
import { Heading } from '../design-system';

import { LinkWithQuery } from './LinkWithQuery';

const Wrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  flex-grow: 1;
  justify-content: center;
  align-items: left;
  border: 1px solid ${({ theme }) => rgba(theme.borderColor.DEFAULT, 0.55)};
  height: 100%;
  padding: 38px 35px;
  max-width: 450px;

  p {
    text-align: left;
  }

  img {
    max-width: 280px;
    filter: none;
    padding-bottom: 0.5rem;
  }

  @media (max-width: ${({ theme }) => theme.mediaQuery.MEDIUM}) {
    width: 100%;
    max-width: none;
    padding: 30px;
  }

  @media (max-width: ${({ theme }) => theme.mediaQuery.SMALL}) {
    img {
      width: 90%;
    }
  }
`;

const Top = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;

  img {
    filter: none;
    margin-bottom: 10px;
    max-width: 280px;
    object-fit: contain;
  }

  @media (max-width: ${({ theme }) => theme.mediaQuery.SMALL}) {
    img {
      width: 90%;
    }
  }
`;

const Bottom = styled.div`
  display: flex;
  flex-direction: column;

  h3 {
    margin-bottom: 12px;
  }

  img {
    max-height: 35px;
    object-fit: contain;
  }

  @media (max-width: ${({ theme }) => theme.mediaQuery.SMALL}) {
    h3 {
      margin-bottom: 7px;
    }
  }
`;

const CardCopy = styled.div`
  display: flex;

  img {
    max-height: 35px;
    object-fit: contain;
  }
`;

const CheckThemOutLink = styled(LinkWithQuery)`
  display: inline-flex;
  align-items: center;
  gap: 4px;
`;

export const G2SocialProofCard: React.ComponentType = React.memo(() => {
  return (
    <Wrapper>
      <Top>
        <img
          alt="Three G2 badges received by Hex for High Performer, Best Support, and Momentum Leader."
          loading="lazy"
          src="https://images.ctfassets.net/mmgv7yhaaeds/6YeFcloKHpe0I7Ax0ihCah/df75892072dc00db9f5865be3a493e33/G2_Badges_Q3_2023.webp"
        />
      </Top>
      <Bottom>
        <Heading renderAs="h3">Users love Hex</Heading>
        <CardCopy>
          <p>
            Rated on G2 as an industry leader based on customer reviews.{' '}
            <CheckThemOutLink
              isExternal={true}
              to="https://www.g2.com/products/hex-technologies/reviews">
              Check them out
              <ArrowRightIcon />
            </CheckThemOutLink>
          </p>
        </CardCopy>
      </Bottom>
    </Wrapper>
  );
});
